export const getUploadedCoverItems = (files: any) =>
  Object.values(files).map((item: any) => ({
    url: item.url,
    name: item.name,
  }));
